import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_mobile-footer_desktopapp_modalview_on_google_play-click';

/**
 * Click on “View on Google Play”
 */
export function trackRetailerMobileFooterDesktopappModalviewOnGooglePlayClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
